import React, { useEffect, useState } from 'react';
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	SettingFilled,
	ProfileFilled,
	ReadFilled,
	AppstoreFilled,
	UserAddOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Button, theme, Modal } from 'antd';
import './Layout.scss';
import { useNavigate, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/Store/Store';
import Avatar from './components/Avatar/Avatar';
import useLogout from '@/Apis/hooks/mutations/useLogout/useLogout';
import { removeToken, setUserProfile } from '@/Store/Modules/User';
import useUserProfile from '@/Apis/hooks/queries/useUserProfile/useUserProfile';
import useGetAuth from '@/hooks/useGetAuth';

const { Header, Sider, Content } = Layout;

const LayoutContainer: React.FC = () => {
	const [collapsed, setCollapsed] = useState(false);
	const {
		token: { colorBgContainer, borderRadiusLG },
	} = theme.useToken();
	const location = useLocation();
	const selectedKey = location.pathname;
	const navigate = useNavigate();

	const token =
		useAppSelector((state) => state.user.token) ||
		localStorage.getItem('token');

	const { isAuthAddAccount } = useGetAuth();

	const { mutate: logoutUser } = useLogout();
	const { data: userProfile } = useUserProfile({
		enabled: !!token
	});

	const user = useAppSelector((state) => state.user.profile);
	const dispatch = useAppDispatch();

	const handleMenuClick = (e: any) => {
		if (!e || !e.key) {
			console.log('handleMenuClick e.key undefined');
			return;
		}
		console.log('handleMenuClick e.key', e.key);
		navigate(e.key);
	};

	const handleLogout = () => {
		logoutUser(undefined, {
			onSuccess: () => {
				dispatch(removeToken());
				navigate('/login');
			},
		});
	};

	const handleClickLogout = () => {
		Modal.confirm({
			title: 'Do you want to logout ?',
			onOk: handleLogout,
		});
	};

	useEffect(() => {
		if (token && userProfile) {
			dispatch(setUserProfile(userProfile));
		}
	}, [token, userProfile, dispatch]);

	if (!token) {
		return <Navigate to='/login' />;
	}

	return (
		<Layout hasSider>
			<Sider
				trigger={null}
				collapsible
				collapsed={collapsed}
				style={{
					overflow: 'auto',
					height: '100vh',
					position: 'fixed',
					left: 0,
					top: 0,
					bottom: 0,
				}}
			>
				<div className='layout-logo-vertical'>LCMP</div>
				<Menu
					theme='dark'
					mode='inline'
					selectedKeys={[selectedKey]}
					onClick={handleMenuClick}
					items={[
						{
							key: '/',
							icon: <AppstoreFilled />,
							label: 'Module Manage',
						},
						{
							key: '/page',
							icon: <ReadFilled />,
							label: 'Page Manage',
						},
						{
							key: '/copywriting',
							icon: <ProfileFilled />,
							label: 'Copywriting Manage',
						},
						...(isAuthAddAccount
							? [
									{
										key: '/register',
										icon: <UserAddOutlined />,
										label: 'Register a User',
									},
							  ]
							: []),
						{
							key: '/log',
							icon: <SettingFilled />,
							label: 'Log',
						},
					]}
				/>
			</Sider>
			<Layout
				style={
					collapsed
						? { marginLeft: 80, minHeight: '100vh' }
						: { marginLeft: 200, minHeight: '100vh' }
				}
			>
				<Header
					style={{
						paddingLeft: 0,
						background: colorBgContainer,
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Button
						type='text'
						icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
						onClick={() => setCollapsed(!collapsed)}
						style={{
							fontSize: '16px',
							width: 64,
							height: 64,
						}}
					/>

					<Avatar
						username={user.nickname || user.account}
						onLogout={handleClickLogout}
					/>
				</Header>
				<Content
					style={{
						margin: '24px 16px',
						padding: 24,
						overflow: 'initial',
						background: colorBgContainer,
						borderRadius: borderRadiusLG,
					}}
				>
					{/* Secondary route exit */}
					<Outlet />
				</Content>
			</Layout>
		</Layout>
	);
};

export default LayoutContainer;
